export const enum SelectionTypeEnum {
    bySeat = 1,
    byTable = 2,
    none = 0
}

export const SELECTION_OPTIONS = [{
        value: SelectionTypeEnum.bySeat,
        label: "Por asiento"
    }, {
        value: SelectionTypeEnum.byTable,
        label: "Por mesa"
    }]